import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { CONSULTANT_SEARCH_ORDER_CANDIDATES, CONSULTANT_SEARCH_SEMINAR_ORDER_CANDIDATES, CONSULTANT_SEARCH_SLIDE_ORDER_CANDIDATES, CONSULTANT_SEARCH_PS_SLIDE_ORDER_CANDIDATES, } from '../../../../define/consts/consultant_search';
import { propArrayNum, propArrayShape, propArrayStr, propBool, propFunc, propNumber, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import ConsultantSearchAll from '../Consultants';
import ConsultantSearchSelect from '../Form/ConsultantSearchSelect';
import ConsultantSearchNoResults from '../NoResults';
import ConsultantPsSearchSlide from '../PsSlide';
import ConsultantSeminar from '../Seminar';
import ConsultantSearchServices from '../Services';
import ConsultantSearchSlide from '../Slide';
import ConsultantSearchSlideLogin from '../Slide/ConsultantSearchSlideLogin';
const ConsultantSearchTabContent = (props) => {
    const { hasSlideRole, isAdmin, isClient, isDisableLink, isGuest, isLg, isMd, isNoResult, isPre, isProfessional, isShowLoginModal, keyword, locationSearch, onChangeOrder, onChangePsSlideOrder, onChangePsSlideSearchType, onChangeSearch, onChangeSeminarOrder, onChangeSeminarTypes, onChangeSlideOrder, onChangeSlideSearchType, onClickForLinkEvent, onClickLoginClose, onClickProjectCountLink, onClickSeminarDocumentLink, onClickSlide, onClickSlideClip, onSubmitLogin, order, professionalPage, psSlideOrder, psSlidePage, psSlideSearchType, scrollToRegistrationForm, search, seminarOrder, seminarPage, seminarThemes, seminarTypes, sendPickup, slideFavoriteMap, slideOrder, slidePage, slideSearchType, solutionPage, total, updateProfile, viewSeminarThemes, } = props;
    const isSearch = search === 'search';
    const isService = search === 'service';
    const isSeminar = search === 'seminar';
    const isSlide = search === 'slide';
    const isPsSlide = search === 'psSlide';
    const defaultOrderConfig = {
        name: 'order',
        onChange: onChangeOrder,
        options: CONSULTANT_SEARCH_ORDER_CANDIDATES,
        order,
    };
    const customOrderConfig = {
        psSlide: {
            name: 'psSlideOrder',
            onChange: onChangePsSlideOrder,
            options: CONSULTANT_SEARCH_PS_SLIDE_ORDER_CANDIDATES,
            order: psSlideOrder,
        },
        seminar: {
            name: 'seminar',
            onChange: onChangeSeminarOrder,
            options: CONSULTANT_SEARCH_SEMINAR_ORDER_CANDIDATES,
            order: seminarOrder,
        },
        slide: {
            name: 'slideOrder',
            onChange: onChangeSlideOrder,
            options: CONSULTANT_SEARCH_SLIDE_ORDER_CANDIDATES,
            order: slideOrder,
        },
    };
    const orderConfig = customOrderConfig[search] || defaultOrderConfig;
    return (_jsxs(_Fragment, { children: [_jsx(ConsultantSearchSelect, { hasSlideRole: hasSlideRole, isDisabled: !isClient, isSeminar: isSeminar, isShowPsSlide: isClient && isPsSlide, isSlide: isSlide, name: orderConfig.name, onChange: orderConfig.onChange, onChangePsSlideSearchType: onChangePsSlideSearchType, onChangeSeminarTypes: onChangeSeminarTypes, onChangeSlideSearchType: onChangeSlideSearchType, onClickDisabledSort: scrollToRegistrationForm, options: orderConfig.options, order: orderConfig.order, psSlideSearchType: psSlideSearchType, seminarTypes: seminarTypes, slideSearchType: slideSearchType, total: total }), isNoResult && (_jsx("div", Object.assign({ className: 'search_list_block_all' }, { children: _jsx(ConsultantSearchNoResults, { formPrefix: `ConsultantSearchTabContent_${search}`, isClient: isClient, keyword: keyword, search: search, sendPickup: sendPickup }) }))), _jsx(ConsultantSearchAll, { isClient: isClient, isGuest: isGuest, isLg: isLg, isMd: isMd, isNoResult: isNoResult, isPre: isPre, isShow: isSearch, keyword: keyword, locationSearch: locationSearch, onChangeSearch: onChangeSearch, onClickForLinkEvent: onClickForLinkEvent, onClickProjectCountLink: onClickProjectCountLink, professionalPage: professionalPage, solutionPage: solutionPage }), _jsx(ConsultantSearchServices, { isClient: isClient, isDisableLink: isDisableLink, isLg: isLg, isMd: isMd, isNoResult: isNoResult, isPre: isPre, isShow: isService, keyword: keyword, onChangeSearch: onChangeSearch, onClickForLinkEvent: onClickForLinkEvent, professionalPage: professionalPage, solutionPage: solutionPage }), _jsx(ConsultantSeminar, { isClient: isClient, isNoResult: isNoResult, isProfessional: isProfessional, isShow: isSeminar, onClickDocumentLink: onClickSeminarDocumentLink, onClickDocumentLinkByGuest: scrollToRegistrationForm, onClickSearchResult: onClickForLinkEvent, seminarPage: seminarPage, seminarThemes: seminarThemes, viewSeminarThemes: viewSeminarThemes }), isAdmin && (_jsxs(_Fragment, { children: [_jsx(ConsultantSearchSlideLogin, { hasSlideRole: hasSlideRole, isShowLoginModal: isShowLoginModal, onClickLoginClose: onClickLoginClose, onSubmitLogin: onSubmitLogin, updateProfile: updateProfile }), hasSlideRole && (_jsx(ConsultantSearchSlide, { isShow: isSlide && !isNoResult, keyword: keyword, onClickSlide: onClickSlide, onClickSlideClip: onClickSlideClip, slideFavoriteMap: slideFavoriteMap, slidePage: slidePage }))] })), isClient && (_jsx(ConsultantPsSearchSlide, { isShow: isPsSlide, psSlidePage: psSlidePage }))] }));
};
ConsultantSearchTabContent.propTypes = {
    hasSlideRole: propBool().isRequired,
    isAdmin: propBool().isRequired,
    isClient: propBool().isRequired,
    isDisableLink: propBool().isRequired,
    isGuest: propBool().isRequired,
    isLg: propBool().isRequired,
    isMd: propBool().isRequired,
    isNoResult: propBool().isRequired,
    isPre: propBool().isRequired,
    isProfessional: propBool().isRequired,
    isShowLoginModal: propBool().isRequired,
    keyword: propStr().isRequired,
    locationSearch: propStr().isRequired,
    onChangeOrder: propFunc().isRequired,
    onChangePsSlideOrder: propFunc().isRequired,
    onChangePsSlideSearchType: propFunc().isRequired,
    onChangeSearch: propFunc().isRequired,
    onChangeSeminarOrder: propFunc().isRequired,
    onChangeSeminarTypes: propFunc().isRequired,
    onChangeSlideOrder: propFunc().isRequired,
    onChangeSlideSearchType: propFunc().isRequired,
    onClickForLinkEvent: propFunc().isRequired,
    onClickLoginClose: propFunc().isRequired,
    onClickProjectCountLink: propFunc().isRequired,
    onClickSeminarDocumentLink: propFunc().isRequired,
    onClickSlide: propFunc().isRequired,
    onClickSlideClip: propFunc().isRequired,
    onSubmitLogin: propFunc().isRequired,
    order: propStr().isRequired,
    professionalPage: propShape().isRequired,
    psSlideOrder: propStr().isRequired,
    psSlidePage: propShape().isRequired,
    psSlideSearchType: propStr().isRequired,
    scrollToRegistrationForm: propFunc().isRequired,
    search: propStr().isRequired,
    seminarOrder: propStr().isRequired,
    seminarPage: propShape().isRequired,
    seminarThemes: propArrayNum().isRequired,
    seminarTypes: propArrayStr().isRequired,
    sendPickup: propFunc().isRequired,
    slideFavoriteMap: propShape().isRequired,
    slideOrder: propStr().isRequired,
    slidePage: propShape().isRequired,
    slideSearchType: propStr().isRequired,
    solutionPage: propShape().isRequired,
    total: propNumber().isRequired,
    updateProfile: propFunc().isRequired,
    viewSeminarThemes: propArrayShape().isRequired,
};
export default ConsultantSearchTabContent;
